
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class PermissionModal extends Vue {
	@Prop({required: true})
	value!: boolean;

	@Prop({required: true})
	title!: string;

	@Prop({default: ''})
	body!: string;

	@Prop({type: Boolean, default: false})
	hideCancel!: boolean;

	@Prop({default: 'Confirm'})
	confirmText!: string;

	@Prop({default: 'Cancel'})
	cancelText!: string;

	cancel() {
		this.$emit('input', false);
		this.$emit('cancel');
	}
}
